import { usePathname } from 'next/navigation';
import usePublicSearchContext from '@/publicSearch/store/usePublicSearchContext';

/**
 * Society-scoped public database UI: /{orgName}/animals|members|sales|external/...
 * Root `/search` is the org-picker page (main marketing header).
 */
const SOCIETY_PUBLIC_SEARCH =
  /^\/[^/]+\/(animals|members|sales|external)(\/|$)/;

/** Mating predictor (pedigree + EPA) lives under /{org}/animals/mating — same public society context. */
const SOCIETY_MATING_PREDICTOR = /^\/[^/]+\/animals\/mating(\/|\?|$)/;

export function useIsPublicSearch() {
  const pathname = usePathname() ?? '';
  // When the URL's societyCode couldn't be resolved, the society layout flags
  // `notFound` on the store and renders a 404 page. In that case we don't
  // want the site header to keep rendering the society-scoped variant (with
  // its perpetual tabs skeleton) — fall back to the generic nav.
  const notFound = usePublicSearchContext((state) => state.society.notFound);

  const matchesSocietyRoute =
    SOCIETY_PUBLIC_SEARCH.test(pathname) ||
    SOCIETY_MATING_PREDICTOR.test(pathname);

  return matchesSocietyRoute && !notFound;
}
